import React from 'react';
import { Link } from 'react-router-dom';
import s from '../../styles/corporate/Corporate.module.css';
import { APPLY_PATH, MARQUEE_WORDS } from './data';

const BIG_TICKER = [...MARQUEE_WORDS, ...MARQUEE_WORDS];

/** 문의 — 비즈니스 문의는 접수 페이지로, 채용 문의는 메일로 */
const CorpContact = () => (
  <section className={s.contact} id="contact">
    <div className={s.contactGlow} aria-hidden="true" />

    <div className={`${s.wrap} ${s.contactInner}`}>
      <div className={s.contactHead}>
        <h2 className={`${s.contactTitle} ${s.reveal}`}>
          함께, 더 큰 미래를
          <br />
          <span style={{ color: 'var(--gold-2)' }}>만들어갑니다.</span>
        </h2>
        <p className={`${s.contactLead} ${s.reveal}`} data-delay="100">
          새로운 비즈니스 기회와 성장의 여정을 함께할 파트너와 인재를 기다립니다.
        </p>
      </div>

      <div className={`${s.contactCards} ${s.reveal}`} data-delay="150">
        <Link className={s.contactCard} to={APPLY_PATH}>
          <span className={s.contactCardTop}>
            <span className={s.contactCardTag} translate="no">
              01 — PARTNERSHIP
            </span>
            <span className={s.contactCardArrow} aria-hidden="true">
              ↗
            </span>
          </span>
          <span className={s.contactCardTitle}>비즈니스 문의</span>
        </Link>

        {/* TODO: 채용 문의 연결처 미정. 지금은 고객센터 번호로 전화를 거는 임시값이라
            PC 에서는 동작하지 않고, 모바일에서는 BNPL 상담 창구로 연결된다.
            채용 메일 주소나 채용 공고 주소가 정해지면 교체할 것. */}
        <a className={s.contactCard} href="tel:1544-3230">
          <span className={s.contactCardTop}>
            <span className={s.contactCardTag} translate="no">
              02 — CAREERS
            </span>
            <span className={s.contactCardArrow} aria-hidden="true">
              ↗
            </span>
          </span>
          <span className={s.contactCardTitle}>채용 문의</span>
        </a>
      </div>
    </div>

    <div className={s.bigTicker} aria-hidden="true">
      <div className={s.bigTickerTrack} translate="no">
        {BIG_TICKER.map((word, i) => (
          <span key={`${word}-${i}`}>{word}</span>
        ))}
      </div>
    </div>
  </section>
);

export default CorpContact;
